import request from '@/utils/request'

// 获取统计总数
export function getCounts() {
  return request({
    url: '/admin/api/stats/counts',
    method: 'get'
  })
}

// 获取每月新增用户数
export function getMonthlyNewUsers() {
  return request({
    url: '/admin/api/stats/monthly-new-users',
    method: 'get'
  })
}

// 获取每月新增房源数
export function getMonthlyNewHouses() {
  return request({
    url: '/admin/api/stats/monthly-new-houses',
    method: 'get'
  })
}

// 获取仪表板统计
export function getDashboardStats() {
  return request({
    url: '/admin/api/stats/dashboard',
    method: 'get'
  })
}

// 获取用户统计
export function getUserStats(params) {
  return request({
    url: '/admin/api/stats/users',
    method: 'get',
    params
  })
}

// 获取房源统计
export function getHouseStats(params) {
  return request({
    url: '/admin/api/stats/houses',
    method: 'get',
    params
  })
}

// 导出统计报表
export function exportStats(params) {
  return request({
    url: '/admin/api/stats/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}